module.exports = __webpack_public_path__ + "static/media/triangle-down.76d37c75.svg";